import React from "react";

const ClimateChange = () => {
  return (
    <div className="m-[50px] text-center font-medium text-[20px]">
      Climate Change Indices are coming soon!
    </div>
  );
};

export default ClimateChange;
